import { Alert, Button, Checkbox, Col, Descriptions, Form, FormInstance, Input, Radio, Space } from "antd";
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import AppContext, { AppContextProps } from "../../components/infrastructure/appContext";
import { IProperty, enmControlType } from "../../components/entityManager/interfaces";
import { EquipmentItem } from "../../baseInfo/equipment/equipmentItem";
import { Brand } from "../../baseInfo/brand";
import { EquipmentModel } from "../../baseInfo/equipmentModel";
import { CustomerEquipmentModelList } from "./customerEquipmentModelList";
import { Province } from "../../baseInfo/province";
import { City } from "../../baseInfo/city";
import { ICallOptions, IFetchingInfo, IResultSet } from "../../components/infrastructure/models";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { IEquipment, IEquipmentItemProps, IEquipmentProblem } from "../../baseInfo/equipment/interfaces";
import { Redirect } from "react-router";
import { ArrowLeftOutlined, BarsOutlined, FileProtectOutlined, IssuesCloseOutlined, StopOutlined, InfoCircleFilled } from "@ant-design/icons";
import { Lookup } from "../../components/lookup";
import TextArea from "antd/lib/input/TextArea";
import { enmSendMethods, sendMethodsOptions } from "../../baseInfo/repairCase/interfaces";
import { ICity, ICityProps } from "../../baseInfo/city/interfaces";
import { IProvince, IProvinceProps } from "../../baseInfo/province/interfaces";
import SimpleMap from "../../components/map";
import { IBrand } from "../../baseInfo/brand/interfaces";
import { IEquipmentModel, IEquipmentModelProps } from "../../baseInfo/equipmentModel/interfaces";
import { ICustomerEquipmentModel } from "../../baseInfo/customerEquipmentModel/interfaces";
import { AttachmentUploader } from "../../baseInfo/attachment/attachmentUploader";
import { IAttachment } from "../../baseInfo/attachment/interfaces";
import { Core } from "../../components/infrastructure/core";
import { Link } from "react-router-dom";

interface IRepairCaseCreateProps extends IBaseProps {
    close?: () => void;
}

interface IRepairCaseCreateStates extends IBaseStates {
    emergencyCallNumber: string;
    problems: IProblem[];
    saved?: boolean;
    equipment?: IEquipment;
    brand?: IBrand;
    brandTitle?: string;
    equipmentModel?: IEquipmentModel;
    equipmentModelTitle?: string;
    serialOrIMEI?: string;
    province?: IProvince;
    city?: ICity;
    address?: string;
    description?: string;
    sendMethod?: enmSendMethods;
    attachments: IAttachment[];
    inquiryIMEIisPassed?: boolean;
}

interface IProblem {
    Id: number;
    Name: string;
    Selected: boolean;
    Code: string;
}

const ProblemsList = (props: { items: IProblem[], onChange: (items: IProblem[]) => void; }) => {
    const list = props.items.map(item =>
        <Descriptions.Item key={item.Id} >
            <Checkbox defaultChecked={item.Selected} onChange={(e) => {
                props.items.find(i => i.Id === item.Id)!.Selected = e.target.checked;
                props.onChange(props.items);
            }}>
                {item.Name}
            </Checkbox>
        </Descriptions.Item>);
    return (
        <Descriptions key="ProblemsList" layout='horizontal' column={{ xxl: 6, xl: 4, lg: 3, md: 2, sm: 2, xs: 1 }}>
            {list}
        </Descriptions>
    );
}

export class RepairCaseCreate extends BaseComponent<IRepairCaseCreateProps, IRepairCaseCreateStates>{
    static contextType = AppContext;
    _form?: FormInstance;

    customerEquipmentModelProp: IProperty;
    equipmentProp: IProperty;
    brandProp: IProperty;
    equipmentModelProp: IProperty;
    provinceProp: IProperty;
    cityProp: IProperty;
    container?: HTMLDivElement | null;

    constructor(props: IRepairCaseCreateProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            emergencyCallNumber: '',
            problems: [],
            attachments: []
        };

        this.title = "ثبت درخواست تعمیرات (آزاد)";

        this.customerEquipmentModelProp = {
            controlType: enmControlType.lookup,
            dataIndex: "PolicyEquipmentModelId",
            width: "100%",
            lookup: {
                lookupComponent: CustomerEquipmentModelList,
                lookupProperty: "EquipmentSerialNo",
                lookupDisplayFields: ["EquipmentSerialNo"],
                dropdownDisplayFields: ["EquipmentSerialNo", "BrandTitle", "EquipmentModelTitle", "EquipmentTitle"],
                showButton: false,

            }
        };
        this.equipmentProp = {
            controlType: enmControlType.lookup,
            dataIndex: "EquipmentId",
            width: "100%",
            lookup: {
                lookupComponent: EquipmentItem,
                lookupProperty: "Code",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
        this.brandProp = {
            controlType: enmControlType.lookup,
            dataIndex: "BrandId",
            width: "100%",
            lookup: {
                lookupComponent: Brand,
                lookupProperty: "Code",
                lookupDisplayFields: ["Name"],
                showButton: false
            }
        };
        this.equipmentModelProp = {
            controlType: enmControlType.lookup,
            dataIndex: "EquipmentModelId",
            width: "100%",
            lookup: {
                lookupComponent: EquipmentModel,
                lookupProperty: "Code",
                lookupDisplayFields: ["Name"],
                showButton: false

            }
        };
        this.provinceProp = {
            controlType: enmControlType.lookup,
            dataIndex: "ProvinceId",
            width: "100%",
            lookup: {
                lookupComponent: Province,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
        this.cityProp = {
            controlType: enmControlType.lookup,
            dataIndex: "CityId",
            width: "100%",
            lookup: {
                lookupComponent: City,
                lookupProperty: "Id",
                lookupDisplayFields: ["Name"],
                showButton: false,
                dropdownDisplayFields: ["Name"]
            }
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.initializing();
    }
    initializing = () => {
        const { getUserInfo } = this.context as AppContextProps;
        const userInfo = getUserInfo();

        this._form?.setFields([
            { name: 'emergencyCallNumber', value: userInfo?.phone ? '0' + userInfo.phone : '', }
        ]);
        this.setState({ emergencyCallNumber: userInfo?.phone ? '0' + userInfo.phone : '', loading: false });
    }
    getProblems = (equipmentId: number) => {
        let fetchingInfo: IFetchingInfo = {
            Orderings: [],
            Filter: ComparisonFilter.Equal<IEquipmentProblem>(e => e.EquipmentId, equipmentId)
        };
        if (!equipmentId) {
            this.setState({ problems: [] });
            return;
        }
        let fetchOpt: ICallOptions = {
            url: "equipmentproblem/get",
            data: {
                fetchingInfo
            },
            onSuccess: (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    let data = (result.Data ?? []) as IEquipmentProblem[];
                    this.setState({
                        problems: data.map(e => {
                            return { Code: e.Problem.Code, Id: e.ProblemId, Name: e.Problem.Name, Selected: false } as IProblem;
                        })
                    });
                }
            },
            onError: () => {

            }
        };
        this.callApi(fetchOpt);
    }
    onChangeSerialOrIMEI = (serialOrIMEI?: ICustomerEquipmentModel | string) => {
        let resetFields = false;
        let customerEquipmentModel: ICustomerEquipmentModel | undefined = undefined;
        if (typeof (serialOrIMEI) === 'string') {
            if (serialOrIMEI !== this.state.serialOrIMEI) {
                resetFields = true;
                this.setState({
                    equipment: undefined,
                    brand: undefined,
                    brandTitle: undefined,
                    equipmentModel: undefined,
                    equipmentModelTitle: undefined,
                    serialOrIMEI: serialOrIMEI as string,
                    inquiryIMEIisPassed: false
                });
            }
        }
        else {
            resetFields = true;
            customerEquipmentModel = serialOrIMEI as ICustomerEquipmentModel;
            this.setState({
                equipment: customerEquipmentModel?.Equipment,
                brand: customerEquipmentModel?.Brand,
                brandTitle: customerEquipmentModel?.Brand ? undefined : customerEquipmentModel?.BrandTitle,
                equipmentModel: customerEquipmentModel?.EquipmentModel,
                equipmentModelTitle: customerEquipmentModel?.EquipmentModel ? undefined : customerEquipmentModel?.EquipmentModelTitle,
                serialOrIMEI: customerEquipmentModel?.EquipmentSerialNo,
                inquiryIMEIisPassed: !!customerEquipmentModel
            });
            this.getProblems(customerEquipmentModel?.EquipmentId);
        }

        if (resetFields) {
            this._form?.resetFields(['equipment', 'brand', 'equipmentModel']);
            this._form?.setFields([
                { name: "equipment", value: customerEquipmentModel?.Equipment },
                { name: 'brand', value: customerEquipmentModel?.Brand },
                { name: 'equipmentModel', value: customerEquipmentModel?.EquipmentModel }
            ]);
        }
    }
    onChangeEquipment = (equipment: IEquipment) => {
        this.setState({ equipment, equipmentModel: undefined });
        this._form?.resetFields(["equipmentModel"]);
        this._form?.setFields([{ name: "equipmentModel", value: null }]);
        this.getProblems(equipment?.Id);

        this.getEquipmentBySerialOrIMEI(equipment?.Id, this.state.serialOrIMEI);
    }
    onChangeBrand = (brand: IBrand | string) => {
        let resetEquipmentModel = false;
        if (typeof (brand) === 'string') {
            if (brand !== this.state.brand?.Name) {
                resetEquipmentModel = true;
                this.setState({ brandTitle: brand as string, brand: undefined, equipmentModel: undefined, equipmentModelTitle: undefined });
            }
        }
        else {
            resetEquipmentModel = true;
            this.setState({ brand: brand as IBrand, brandTitle: undefined, equipmentModel: undefined, equipmentModelTitle: undefined });
        }

        if (resetEquipmentModel) {
            this._form?.resetFields(["equipmentModel"]);
            this._form?.setFields([{ name: "equipmentModel", value: null }]);
        }
        else {
            this._form?.setFields([{ name: "brand", value: this.state.brandTitle ?? this.state.brand }]);
        }
    }
    onChangeProvince = (province?: IProvince) => {
        this.setState({ province: province, city: undefined });
        this._form?.resetFields(["city"]);
        this._form?.setFields([{ name: "city", value: null }]);
    }
    onChangeCity = (city?: ICity) => {
        const province = city?.Province;
        if (!this.state.province) {
            this._form?.resetFields(["province"]);
            this._form?.setFields([{ name: "province", value: province }]);
            this.setState({ city, province });
        }
        else
            this.setState({ city });
    }
    equipmentPreparelookupProps = (props: IEquipmentItemProps) => {
        props.params = () => {
            return {
                codes: ["1", "2", "5", "16"],
                onlySubItems: true
            }
        };
        return props;
    }
    onChangeEquipmentModel = (equipmentModel: IEquipmentModel | string) => {
        if (typeof (equipmentModel) === 'string') {
            if (equipmentModel !== this.state.equipmentModel?.Name)
                this.setState({ equipmentModelTitle: equipmentModel as string, equipmentModel: undefined });
            else {
                this._form?.setFields([{ name: "equipmentModel", value: this.state.equipmentModelTitle ?? this.state.equipmentModel }]);
            }
        }
        else {
            this.setState({ equipmentModel: equipmentModel as IEquipmentModel, equipmentModelTitle: undefined });
        }
    }
    equipmentModelPreparelookupProps = (props: IEquipmentModelProps) => {
        props.params = () => {
            return {
                brand: this.state.brand,
                equipment: this.state.equipment
            }
        }
        return props;
    }
    provincePreparelookupProps = (lookupProps: IProvinceProps) => {
        lookupProps.params = () => {
            return {
                codes: ["7"]
            };
        };
        return lookupProps;
    }
    cityPreparelookupProps = (lookupProps: ICityProps) => {
        lookupProps.params = () => {
            let province = this.state.province;
            return { province, codes: ["701"] };
        };
        return lookupProps;
    }
    submitRequest = async () => {
        const { getUserInfo } = this.context as AppContextProps;
        const userInfo = getUserInfo();
        const nationalCode = userInfo?.userName;

        let repairCase = {
            Policyholder: { NationalCode: nationalCode },
            EmergencyCallNumber: this.state.emergencyCallNumber,
            ProvinceCode: this.state.province?.Code,
            CityCode: this.state.city?.Code,
            Address: this.state.address,
            Description: this.state.description,
            SendMethod: this.state.sendMethod,
            EquipmentModel: {
                EquipmentId: this.state?.equipment?.Id,
                BrandCode: this.state?.brand?.Code,
                BrandTitle: this.state?.brandTitle,
                EquipmentModelCode: this.state?.equipmentModel?.Code,
                EquipmentModelTitle: this.state?.equipmentModelTitle,
                SerialOrIMEI: this.state?.serialOrIMEI
            },
            Problems: this.state.problems.filter(p => p.Selected).map(p => p.Code)
        };

        let formData = new FormData();
        formData.append('RepairCase', JSON.stringify(repairCase));

        for (let i = 0; i < this.state.attachments.length; i++) {
            formData.append('Attachments', (this.state.attachments[i] as any).File);
            formData.append('AttachmentDescriptions', this.state.attachments[i].Description ?? '');
        }

        let opt: ICallOptions = {
            withBlock: true,
            withBlockTitle: 'در حال ثبت درخواست تعمیرات...',
            url: "portal/repairrequest",
            data: formData,
            contentType: false,
            headers: [{ key: "encType", value: "multipart/form-data" }],
            onSuccess: (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification(result.ValidationState.ValidationResults[0].Message);
                    this.setState({ saved: true });
                }
            }
        };
        await this.callApi(opt);
    }
    onChangeAttachments = (attachments: IAttachment[]) => {
        this.setState({ attachments });
    }
    getEquipmentBySerialOrIMEI = async (equipmentId?: number, serialOrIMEI?: string) => {
        if (equipmentId === 4) {
             await this._form?.validateFields(['serialOrIMEI']);
        }
        else if (equipmentId !== 4) {
            if (!!equipmentId)
                this.setState({ inquiryIMEIisPassed: true });
            return;
        }
        let fetchOpt: ICallOptions = {
            withBlock: true,
            withBlockTitle: 'در حال استعلام سریال یا IMEI...',
            url: "portal/getEquipmentBySerialOrIMEI",
            data: {
                equipmentSerialNoOrIMEI: serialOrIMEI
            },
            onSuccess: (result: IResultSet<IEquipmentModel>) => {
                if (result.ValidationState.Successful) {
                    this.setState({
                        brand: result.Data?.Brand,
                        equipmentModel: result.Data,
                        inquiryIMEIisPassed: true
                    });
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    virtualRender() {

        const { getUserInfo } = this.context as AppContextProps;
        const { extraVariables } = getUserInfo()!;

        const header = this.getPageHeader({
            title: this.title,
            extraHeaderNodes: (
                <>
                    <Alert
                        style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                        message={
                            <>
                                {extraVariables["IsPolicyholder"] && <p style={{ fontWeight: 600, fontSize: 18, margin: "15px 0px" }}>
                                    <InfoCircleFilled className="blink" style={{ color: '#1890ff', margin: 5, marginRight: 0, verticalAlign: 'top' }} />
                                    بیمه گزار/مشتری گرامی، در صورتی که در حال حاضر صاحب بیمه هستید و به خسارت خورده اید، از طریق <Link to="/damagecasecreate">"ثبت خسارت بیمه نامه"</Link> نسبت به ثبت درخواست خسارت اقدام نمایید و در صورتیکه که تمایل به تعمیرات آزاد خارج از بیمه نامه دارید، فُرم زیر را تکمیل نمایید.
                                </p>}
                                <p style={{ fontSize: 18, margin: "15px 0px" }}>
                                    {!extraVariables["IsPolicyholder"] && <InfoCircleFilled className="blink" style={{ color: '#1890ff', margin: 5, marginRight: 0, verticalAlign: 'top' }} />}
                                    فرآیند ثبت درخواست تعمیرات:
                                </p>
                                <p style={{ fontSize: 16 }}>
                                    پس از وارد کردن اطلاعات خواسته شده در فیلد مخصوص و تکمیل فرآیند ثبت درخواست تعمیرات موبایل،‌ روی دکمه (ثبت درخواست) کلیک کنید.
                                    <br />
                                    پس از ثبت و نهایی سازی درخواست تعمیرات، پیامکی مبنی بر تأیید ثبت درخواست توسط شرکت زبده دریافت خواهید کرد.
                                    <br />
                                    در این مرحله کارشناسان بخش تعمیرات پس از تأیید و استعلام قیمت و بررسی دقیق مشکل دستگاه هزینه تقریبی تعمیرات را برای شما در نرم افزار ثبت خواهند نمود.
                                    <br />
                                    پس از هماهنگی با کارشناس مربوطه،‌ ارسال گوشی جهت تعمیر به انتخاب شما به صورت حضوری یا توسط پیک به شرکت زبده صورت می‌گیرد.
                                    <br />
                                    در این مرحله یک‌ کد رهگیری به شماره تماس شما ارسال خواهد شد،‌ که دریافت این کد به منزله تأیید ارسال گوشی توسط شما به نمایندگی مورد نظر بوده و به کمک آن می‌توانید فرآیند تعمیرات دستگاه خود را بررسی کنید.
                                </p>
                                <div style={{ fontSize: 16 }}>
                                    هنگام ثبت درخواست به نکات زیر توجه کنید:
                                    <ul>
                                        <ol>1. در حین ثبت درخواست، تمامی اطلاعات خواسته شده را صحیح وارد کرده و حتی الامکان توضیحات را کامل و دقیق ثبت نمایید.</ol>
                                        <ol>2. توجه داشته باشید،‌ که پس از ارسال دستگاه دریافت کد پیگیری ضروری است.</ol>
                                        <ol>3. در صورتی که شماره همراه فعال ندارید،‌ حتما یک شماره تماس ثابت جهت ارتباط با نماینده در فیلد توضیحات ثبت کنید.</ol>
                                    </ul>
                                </div>
                            </>
                        }
                        type="info"
                    />
                </>),
            onBack: () => {
                if (this.props.close)
                    this.props.close();
                else
                    window.history.back();
            }
        });

        const zobdehLocation: { Longitude?: number; Latitude?: number; Address?: string; WorkTime?: string; CityName?: string; Phone?: string; } = extraVariables['ZobdehLocation'];

        if (this.state.saved)
            return <Redirect to={"/repaircasepolicyholder"} />

        const span = window.matchMedia("(min-width: 992px)").matches ? 2 : 1;

        return (
            <div ref={node => this.container = node}>
                {header}
                <Form

                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                    layout={'horizontal'}
                    ref={node => { if (node) this._form = node }}
                    onFinish={async () => {
                        await this.submitRequest();
                    }}
                    onReset={() => {
                        if (this.props.close)
                            this.props.close();
                        else
                            window.history.back();
                    }}
                    onFinishFailed={errorInfo => {
                        if (this.container && errorInfo.errorFields.length) {
                            const { name } = errorInfo.errorFields[0];
                            const label = this.container.querySelector(`[for="${name[0]}"]`);
                            label?.scrollIntoView();
                            const field = this._form?.getFieldInstance(name[0]);
                            if (field?.focus)
                                field.focus();
                        }
                    }}
                >
                    <div key="equipmentModelInfo" className="box box-blue">
                        <div className="box-title">
                            <div className="caption">
                                <FileProtectOutlined style={{ margin: 2, verticalAlign: 'text-top' }} />
                                اطلاعات دستگاه
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">

                                <Descriptions layout='horizontal' column={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} >
                                    <Descriptions.Item key="serialOrIMEI">
                                        <Form.Item
                                            key="serialOrIMEI"
                                            name="serialOrIMEI"
                                            label="سریال یا (IMEI)"
                                            style={{ width: "100%" }}
                                            rules={[
                                                {
                                                    validator: () => {
                                                        if (!!this.state.serialOrIMEI && this.state.serialOrIMEI?.length !== 15 && this.state.equipment?.Id === 4)
                                                            return Promise.reject(new Error('شماره سریال یا (IMEI) باید 15 رقم باشد'));
                                                        return Promise.resolve();
                                                    }
                                                },
                                                {
                                                    required: true,
                                                    validator: () => {
                                                        if (!this.state.serialOrIMEI)
                                                            return Promise.reject(new Error('شماره سریال یا (IMEI) اجباری است'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                        >
                                            <Lookup
                                                allowTextChange={true}
                                                parent={this}
                                                key="SerialOrIMEI"
                                                onChange={this.onChangeSerialOrIMEI}
                                                defaultText={this.state.serialOrIMEI}
                                                property={this.customerEquipmentModelProp}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="equipment">
                                        <Form.Item
                                            key="equipment"
                                            name="equipment"
                                            label="دستگاه/تجهیز"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'دستگاه/تجهیز اجباری است' }
                                            ]}
                                        >
                                            <Lookup
                                                key="EquipmentId"
                                                parent={this}
                                                property={this.equipmentProp}
                                                value={this.state.equipment}
                                                onChange={this.onChangeEquipment}
                                                preparelookupProps={this.equipmentPreparelookupProps}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="brand">
                                        <Form.Item
                                            key="brand"
                                            name="brand"
                                            label="برند"
                                            style={{ width: "100%" }}
                                            rules={[
                                                {
                                                    required: true,
                                                    validator: () => {
                                                        if (!this.state.brand && !this.state.brandTitle)
                                                            return Promise.reject(new Error('برند اجباری است'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                        >
                                            <Lookup
                                                disabled={!this.state.inquiryIMEIisPassed}
                                                allowTextChange={true}
                                                parent={this}
                                                key="BrandId"
                                                property={this.brandProp}
                                                onChange={this.onChangeBrand}
                                                defaultText={this.state.brandTitle ?? this.state.brand?.Name}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="equipmentModel">
                                        <Form.Item
                                            key="equipmentModel"
                                            name="equipmentModel"
                                            label="مدل"
                                            style={{ width: "100%" }}
                                            rules={[
                                                {
                                                    required: true,
                                                    validator: () => {
                                                        if (!this.state.equipmentModel && !this.state.equipmentModelTitle)
                                                            return Promise.reject(new Error('مدل اجباری است'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                        >
                                            <Lookup
                                                disabled={!this.state.inquiryIMEIisPassed}
                                                allowTextChange={true}
                                                parent={this}
                                                key="EquipmentModelId"
                                                property={this.equipmentModelProp}
                                                onChange={this.onChangeEquipmentModel}
                                                preparelookupProps={this.equipmentModelPreparelookupProps}
                                                defaultText={this.state.equipmentModelTitle ?? this.state.equipmentModel?.Name}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="emergencyCallNumber" span={1}>
                                        <Form.Item
                                            name="emergencyCallNumber"
                                            key="emergencyCallNumber"
                                            label="شماره موبایل در دسترس"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'شماره موبایل اجباری است' },
                                                { len: 11, message: 'شماره موبایل باید 11 رقم باشد' },
                                                {
                                                    validator: () => {
                                                        if (!this.state.emergencyCallNumber?.startsWith('0'))
                                                            return Promise.reject(new Error('شماره موبایل با 0 آغاز شود'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                            initialValue={this.state.emergencyCallNumber}
                                        >
                                            <Input
                                                type={"text"}
                                                onKeyPress={(event) => {
                                                    if (event.charCode < 48 || event.charCode > 57) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                onChange={e => {
                                                    this.setState({ emergencyCallNumber: e.target.value });
                                                }}
                                                value={this.state.emergencyCallNumber}
                                                maxLength={11}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </div>
                    </div>

                    <div key="damageinfo" className="box box-blue" style={{ marginTop: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <IssuesCloseOutlined style={{ margin: 2, verticalAlign: 'text-top' }} />
                                اطلاعات درخواست
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <Descriptions layout='horizontal' column={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>

                                    <Descriptions.Item key="province">
                                        <Form.Item
                                            name="province"
                                            key="province"
                                            label="استان"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'استان اجباری است' }
                                            ]}
                                        >
                                            <Lookup
                                                parent={this}
                                                onChange={this.onChangeProvince}
                                                property={this.provinceProp}
                                                preparelookupProps={this.provincePreparelookupProps}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="city">
                                        <Form.Item
                                            name="city"
                                            key="city"
                                            label="شهر"
                                            style={{ width: "100%" }}
                                            rules={[
                                                { required: true, message: 'شهر اجباری است' },
                                                {
                                                    validator: () => {
                                                        if (this.state.city && this.state.city?.Code !== "701")
                                                            return Promise.reject(new Error('در حال حاضر فقط ثبت درخواست تعمیر برای شهر تهران امکانپذیر است'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                        >
                                            <Lookup
                                                parent={this}
                                                onChange={this.onChangeCity}
                                                property={this.cityProp}
                                                preparelookupProps={this.cityPreparelookupProps}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="address" span={1}>
                                        <Form.Item
                                            key="address"
                                            name="address"
                                            label="آدرس"
                                            style={{ width: "100%" }}
                                            rules={[{ required: true, message: 'آدرس اجباری است' }]}
                                        >
                                            <TextArea
                                                value={this.state.address}
                                                onChange={e => this.setState({ address: e.target.value })}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="description">
                                        <Form.Item
                                            key="description"
                                            name="description"
                                            label="مشکل دستگاه خود را توضیح  دهید"
                                            style={{ width: "100%" }}
                                            rules={[{ required: true, message: 'توضیحات اجباری است' }]}
                                        >
                                            <TextArea
                                                value={this.state.description}
                                                onChange={e => this.setState({ description: e.target.value })}
                                            />
                                        </Form.Item>
                                    </Descriptions.Item>
                                    <Descriptions.Item key="attachments">
                                        <Form.Item
                                            label={'تصاویر قسمت های آسیب دیده'}
                                            name={'attachments'}
                                            key={'attachments'}
                                            style={{ width: "100%" }}
                                        >
                                            <AttachmentUploader
                                                whiteList='image/png,image/jpg,image/jpeg,application/pdf'
                                                attachments={this.state.attachments}
                                                onChange={this.onChangeAttachments}
                                                disabled={false} />
                                        </Form.Item>
                                    </Descriptions.Item>
                                </Descriptions >
                            </div>
                        </div>
                    </div>

                    {!!this.state.problems.length &&
                        <div key="problems" className="box box-blue" style={{ marginTop: 10 }}>
                            <div className="box-title">
                                <div className="caption">
                                    <BarsOutlined style={{ margin: 2, verticalAlign: 'text-top' }} rotate={180} />
                                    مشکل دستگاه خود را انتخاب نمایید
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">
                                    <Form.Item wrapperCol={{ span: 24 }} key="problemItems">
                                        <ProblemsList items={this.state.problems} onChange={items => this.setState({ problems: items })} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    }

                    <div key="send" className="box box-blue" style={{ marginTop: 10 }}>
                        <div className="box-title">
                            <div className="caption">
                                <BarsOutlined style={{ margin: 2, verticalAlign: 'text-top' }} rotate={180} />
                                روش ارسال
                            </div>
                        </div>
                        <div className="box-body form">
                            <div className="form-body">
                                <Descriptions>
                                    <Descriptions.Item key={'EvaluationMethod'} className="ant-col-24">
                                        <Form.Item
                                            label={'لطفاً روش ارسال دستگاه آسیب دیده خود را انتخاب فرمایید'}
                                            name={'EvaluationMethod'}
                                            key={'EvaluationMethod'}
                                            labelCol={{ style: { lineHeight: 'normal', width: '100%' } }}
                                            wrapperCol={{ span: 16 }}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'پاسخ اجباری است'
                                                },
                                                {
                                                    validator: () => {
                                                        if (this.state.sendMethod && this.state.sendMethod !== enmSendMethods.PolicyholderInPerson)
                                                            return Promise.reject(new Error('در حال حاضر فقط ارسال به صورت حضوری امکانپذیر است'));
                                                        return Promise.resolve();
                                                    }
                                                }
                                            ]}
                                            style={{ width: '100%' }}
                                        >
                                            <Radio.Group key={'SendMethod'} onChange={e => this.setState({ sendMethod: e.target.value })}>
                                                {sendMethodsOptions.filter(s => s.disabled === false).map(s =>
                                                    <Col key={s.value} style={{ marginTop: 10, lineHeight: "normal" }}>
                                                        <Radio key={s.value} value={s.value}>{s.name}</Radio>
                                                    </Col>
                                                )}

                                            </Radio.Group>
                                        </Form.Item>

                                    </Descriptions.Item>
                                    {!!zobdehLocation &&
                                        <Descriptions.Item key="zobdehInfo" className={span === 1 ? "ant-col-24" : "ant-col-12"}>
                                            <Alert type="info" style={{ marginTop: 10 }} message={
                                                <Space direction="vertical">
                                                    <Descriptions >
                                                        <Descriptions.Item label={"آدرس"}> {zobdehLocation.Address}</Descriptions.Item>
                                                    </Descriptions>
                                                    {!!zobdehLocation.Phone &&
                                                        <Descriptions>
                                                            <Descriptions.Item label={"تلفن"}>
                                                                <b style={{ unicodeBidi: "plaintext" }}>{zobdehLocation.Phone.startsWith('9') ? `0${zobdehLocation.Phone}` : `0${zobdehLocation.Phone}`.replace(/\D+/g, '').replace(/(\d{3})(\d+)/, '$1 - $2')}</b>
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                    }
                                                    {!!zobdehLocation.WorkTime &&
                                                        <Descriptions key="workTime">
                                                            <Descriptions.Item label={"ساعت کار"} > {zobdehLocation.WorkTime}</Descriptions.Item>
                                                        </Descriptions>
                                                    }
                                                    {!!zobdehLocation.Latitude &&
                                                        <Descriptions key="map">
                                                            <Descriptions.Item>
                                                                <SimpleMap
                                                                    disableChangeMarker={true}
                                                                    cityName={zobdehLocation.CityName}
                                                                    lat={zobdehLocation.Latitude}
                                                                    lng={zobdehLocation.Longitude}
                                                                />
                                                            </Descriptions.Item>
                                                        </Descriptions>
                                                    }
                                                </Space>
                                            } />
                                        </Descriptions.Item>
                                    }
                                </Descriptions>
                            </div>
                        </div>
                    </div>


                    <Form.Item wrapperCol={{ dir: 'ltr' }} style={{ zIndex: 1000, borderTop: '1px solid', borderColor: '#e5e5e5', marginTop: 10, padding: '10px 45px' }}>
                        <Button type="primary" htmlType="submit" icon={<ArrowLeftOutlined />} loading={this.state.loading} style={{ width: "130px", marginTop: 10, marginBottom: 10 }}>
                            ثبت درخواست
                        </Button>
                        <Button type="ghost" htmlType="reset" icon={<StopOutlined />} loading={this.state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                            انصراف
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}